<script>
import { formatDate } from "@/assets/js/utils";
export default {
  name: "dg-form",
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      }
    },

    items: {
      type: Array,
      default: () => {
        return [];
        //  items  结构示例
        /*
        [
        {
          key: "time,time1",
          label: "创建时间",
          des: "请输入创建时间",
          model: [],
          type: "date",
        },

          { key: "name", label: "名称", des: "请输入名称", type: "input" },
          {
            key: "sex",
            label: "性别",
            des: "请选择性别",
            type: "select",
            options: [
              { key: 0, value: "男" },
              { key: 1, value: "女" },
            ],
          },
        ]
        */
      }
    },
    options: {
      type: Object,
      default: () => {
        return { fold: -1 };
      }
    }
  },
  data() {
    return {
      fold: false,
      open: true,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime());
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "这周",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 - start.getDay()));
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "本月",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * (start.getDate() - 1));
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "上个月",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * (30 + start.getDate()));
              end.setTime(end.getTime() - 3600 * 1000 * 24 * end.getDate());
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },

  methods: {
    renderItem(h) {
      let items = this.items;
      let options = this.options;
      let formData = this.value;
      let nodes = items.map((el) => {
        // let isFold = index >= Number(options.fold) && options.fold != -1;
        // let key = "open";
        // if (isFold) key = "fold";
        el.label = "";
        if (el.type == "input") {
          return h(
            "el-form-item",
            {
              attrs: {
                label: el.label || ""
              },

            },
            [
              h("el-input", {
                attrs: {
                  placeholder: el.des
                },
                style: { width: el.width },
                props: {
                  "prefix-icon": "el-icon-search",
                  clearable: true,
                  value: formData[el.key]
                },
                on: {
                  input: value => {
                    formData[el.key] = value;
                  }
                }
              })
            ]
          );
        }

        if (el.type == "select") {
          return h(
            "el-form-item",
            {
              attrs: {
                label: el.label || ""
              }
            },
            [
              h(
                "el-select",
                {
                  attrs: {
                    filterable: true,
                    clearable: true,
                    placeholder: el.des
                  },
                  props: {
                    value: formData[el.key]
                  },

                  on: {
                    input: value => {

                      formData[el.key] = value;
                      // console.log(formData[el.key]);
                    }
                  }
                },
                [
                  h("el-option", {
                    attrs: {
                      label: "全部",
                      value: ""
                    }
                  }),
                  ...el.options.map(el => {
                    return h("el-option", {
                      attrs: {
                        label: el.value,
                        value: el.key
                      }
                    });
                  })
                ]
              )
            ]
          );
        }

        if (el.type == "date") {
          if (el.key.indexOf(",") == -1) {
            return;
          }
          let begin = el.key.split(",")[0];
          let end = el.key.split(",")[1];
          return h(
            "el-form-item",
            {
              attrs: {
                label: el.label || ""
              }
            },
            [
              h("el-date-picker", {
                props: {
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  type: "daterange",
                  value: el.model,
                  "picker-options": this.pickerOptions
                },
                on: {
                  input: val => {
                    el.model = val;
                    if (val) {
                      formData[begin] = formatDate(val[0]) ? formatDate(val[0]).slice(0, 11) + "00:00:00" : "";
                      formData[end] = formatDate(val[1]) ? formatDate(val[1]).slice(0, 11) + "23:59:59" : "";
                    } else {
                      formData[begin] = "";
                      formData[end] = "";
                    }
                  }
                }
              })
            ]
          );
        }
      });
      if (Number(options.fold) > 0) {
        nodes.splice(
          options.fold,
          0,
          h(
            "el-button",
            {
              class: {
                "mr-[6]": true
              },
              props: {
                size: "small"
              },
              on: {
                click: () => {
                  this.fold = !this.fold;
                }
              }
            },
            this.fold ? "收起" : "展开"
          )
        );
      }
      return [...nodes];
    }
  },
  render(createElement) {
    let   slots = this.$slots && this.$slots.default;
    return createElement('div', {
      class: {
        "dg__form": true,
        "flex": true,
        'pt-[20]': true
      },
    }, [
      createElement('div', {
        class: {
          "flex-1": true
        },
      }, [createElement(
        "el-form",
        {
          props: {
            inline: true,
            size: "small",
            model: this.value,
            "label-suffix": ":"
          },
          ref: "formData"
        },
        [this.renderItem(createElement)]
      )]),
      createElement('div', {
        class: {
          "search-box": true
        },
      }, [slots])
    ])
  },
};
</script>
<style scoped lang="less">
.dg__form {
  background: #fff;
  border-radius: 2px;
  padding: 20px 20px 0px 20px;
  // margin-bottom: 4px;
  overflow: hidden;
}

.el-form--inline .el-form-item {
  margin-right: 20px;
}

.search-box {
  flex-basis: 90px;
  text-align: right;
}

.el-form-item--small.el-form-item {
  margin-bottom: 0px !important;
}
</style>
